// extracted by mini-css-extract-plugin
module.exports = {"drugAudits":"admin-portal__DrugAudits__drugAudits","rightRow":"admin-portal__DrugAudits__rightRow"};